module.exports = __webpack_public_path__ + "img/logo.6ca4a2e4.png";